
















import { Component, Vue } from 'vue-property-decorator';
import { app } from '@store/modules/app';
import { CurrentBanner } from 'types/banner';
import { CurrentModal } from 'types/modal';
import { debounce } from '@utils/dev';
import { getScreenSize } from '@utils/client';
import { stripRouteHash } from '@utils/routing';
import ToastContainer from '@components/layout/toast-container.vue';

/* eslint-disable @typescript-eslint/no-var-requires */
const appConfig = require('./app.config.json');
/* eslint-enable @typescript-eslint/no-var-requires */

@Component({
	metaInfo: {
		titleTemplate(title): string {
			return title ? `${title} | ${appConfig.title}` : appConfig.title;
		},
		meta: [
			{ charset: 'utf-8' },
			{ name: 'viewport', content: 'width=device-width, minimum-scale=1.0, maximum-scale=1.0' },
			{ name: 'twitter:site', content: '@fundrise' },
			{ name: 'apple-mobile-web-app-capable', content: 'yes' },
			{ name: 'p:domain_verify', content: '411182b397074a11ab6dd421b34bc4e8' }
		]
	},
	components: {
		ToastContainer
	}
})
export default class App extends Vue {
	get currentModal(): CurrentModal | null {
		document.body.style.overflow = app.currentModal ? 'hidden' : '';
		return app.currentModal;
	}

	get currentBanner(): CurrentBanner | null {
		return app.currentBanner;
	}

	get routeKey(): string {
		return stripRouteHash(this.$route);
	}

	updateScreenSize(): void {
		app.UPDATE_SCREEN_SIZE(getScreenSize());
	}

	destroyed(): void {
		window.removeEventListener('resize', debounce(this.updateScreenSize, 200));
	}

	async created(): Promise<void> {
		this.updateScreenSize();
		window.addEventListener('load', debounce(this.updateScreenSize, 200));
		window.addEventListener('resize', debounce(this.updateScreenSize, 200));
		await app.initializeLaunchDarklyInstance();
	}

	closeModal(): void {
		app.UPDATE_CURRENT_MODAL(null);
	}
}
